import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import { Field } from 'redux-form';
import ValidatedDatePicker from 'components/ValidatedDatePicker';
import { renderRadioGroup } from './FormFieldRenderers';

const ActivePeriodSection = ({ activePeriodValue }) => (
  <div style={{ marginTop: '1.5em' }}>
    <Field
      name="active_period"
      component={renderRadioGroup}
      label="Custom Package Active Period"
      options={[
        {
          value: 'live_time',
          label: 'Live Time (always active)',
        },
        { value: 'custom_period', label: 'Custom Period' },
      ]}
    />
    {activePeriodValue === 'custom_period' && (
      <Form.Group widths="equal" style={{ marginTop: '1em' }}>
        <Form.Field>
          <label>Start Date</label>
          <Field
            name="start_date"
            component={ValidatedDatePicker}
            placeholder="Select date"
            minDate={new Date()}
          />
        </Form.Field>
        <Form.Field>
          <label>End Date</label>
          <Field
            name="end_date"
            component={ValidatedDatePicker}
            placeholder="Select date"
          />
        </Form.Field>
      </Form.Group>
    )}
  </div>
);

ActivePeriodSection.propTypes = {
  activePeriodValue: PropTypes.string,
};

ActivePeriodSection.defaultProps = {
  activePeriodValue: 'live_time',
};

export default ActivePeriodSection;
